import React from 'react';

export interface AlertProps {
  variant?: 'info' | 'error' | 'success' | 'warning';
  children: React.ReactNode;
  className?: string;
}

const variantClasses: Record<NonNullable<AlertProps['variant']>, string> = {
  info: 'bg-blue-900/50 border-blue-700 text-blue-200',
  error: 'bg-red-900/50 border-red-700 text-red-200',
  success: 'bg-green-900/50 border-green-700 text-green-200',
  warning: 'bg-yellow-900/50 border-yellow-700 text-yellow-200',
};

export const Alert: React.FC<AlertProps> = ({
  variant = 'info',
  children,
  className = '',
}) => {
  return (
    <div
      className={`px-4 py-3 rounded-lg border text-sm ${variantClasses[variant]} ${className}`}
    >
      {children}
    </div>
  );
};
